/* tslint:disable:no-any */
/* tslint:disable:semicolon */
/* tslint:disable:max-line-length */
import 'whatwg-fetch'
import { STORAGE_KEYS, API } from 'src/constants/'
import history from 'src/history'

/**
 * Helper for doing HTTP requests. Uses fetch().
 *
 * @returns A promise with the parsed JSON from the HTTP response body
 * @throws {Error} When received a readable error from the API
 * @throws {TypeError} In case of a network error (i.e. no internect connection, proxy errors, etc.)
 * @throws {SyntaxError} When HTTP response body could not be parsed as JSON
 */

function http(route: string, method: string = 'GET', body?: any): Promise<any> {
    const url = route
    const bearerToken = localStorage.getItem(STORAGE_KEYS.ID_TOKEN)

    let options: any = {
        method: method,
        credentials: 'omit',
        headers: {
            'Accept': 'application/json'
        }
    }

    if (bearerToken) {
        options.headers.Authorization = 'Bearer ' +  bearerToken
    }

    if (body) {
        options.headers['Content-Type'] = 'application/json';
        options.body = JSON.stringify(body)
    }

    const onError = (error: any) => {
        return error.json()
            .then((json: any) => {
                if (json && json.message) {
                    throw new Error(json.message)
                } else if (json && typeof json === 'string') {
                    throw new Error(json)
                } else {
                    throw new Error() // No readable error found
                }
            })
    }

    const onSuccess = (response: Response) => {
        let contentType = response.headers.get('content-type');
        if (contentType && contentType.indexOf('application/json') !== -1) {
            return response.json()
        } else {
            return response
        }
    }

    return fetch(url, options)
        .then((response: Response) => {
            if (response.status === API.status.UNAUTHORIZED) {
                history.replace('/unauthorized')
                return
            }
            if (!response.ok) {
                return onError(response)
            } else {
                return onSuccess(response)
            }
        })
}
export default http



// WEBPACK FOOTER //
// ./src/helpers/Http/index.tsx